// import { api } from "./api";

// function buildFichaPayload(data: any) {
//   const formData = new FormData();

//   Object.entries(data || {}).forEach(([key, value]) => {
//     if (key === "imageFile") return;
//     if (value === undefined || value === null) return;

//     if (value instanceof File) {
//       formData.append(key, value);
//       return;
//     }

//     formData.append(key, String(value));
//   });

//   if (data?.imageFile instanceof File) {
//     formData.append("image", data.imageFile);
//   }

//   return formData;
// }

// export const FichaService = {

//   async findAll() {

//     const response =
//       await api.get(
//         "/fichas"
//       );

//     return response.data;
//   },

//   async findLookup(query: string) {

//     const response = await api.get(
//       "/fichas/lookup",
//       {
//         params: {
//           q: query || ""
//         }
//       }
//     );

//     const data = response.data;

//     if (Array.isArray(data)) {
//       return data;
//     }

//     if (Array.isArray(data?.data)) {
//       return data.data;
//     }

//     return [];
//   },

//   async create(data: any) {

//     const payload = data?.imageFile
//       ? buildFichaPayload(data)
//       : data;

//     const response = await api.post(
//       "/fichas",
//       payload
//     );

//     return response.data;
//   },

//   async update(
//     id: number,
//     data: any
//   ) {

//     const payload = data?.imageFile
//       ? buildFichaPayload(data)
//       : data;

//     const response = await api.put(
//       `/fichas/${id}`,
//       payload
//     );

//     return response.data;
//   },

//   async delete(
//     id: number
//   ) {

//     const response =
//       await api.delete(
//         `/fichas/${id}`
//       );

//     return response.data;
//   }
// };


import { api } from "./api";

function buildFichaPayload(data: any) {
  const formData = new FormData();

  Object.entries(data || {}).forEach(([key, value]) => {
    if (key === "imageFile") return;
    if (value === undefined || value === null) return;

    if (value instanceof File) {
      formData.append(key, value);
      return;
    }

    formData.append(key, String(value));
  });

  if (data?.imageFile instanceof File) {
    formData.append("image", data.imageFile);
  }

  return formData;
}

export const FichaService = {
  async findAll() {
    const response = await api.get("/fichas");
    return response.data;
  },

  async findLookup(query: string) {
    const response = await api.get("/fichas/lookup", { params: { q: query || "" } });
    const data = response.data;
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.data)) return data.data;
    return [];
  },

  async create(data: any) {
    const payload = data?.imageFile ? buildFichaPayload(data) : data;
    const response = await api.post("/fichas", payload);
    return response.data;
  },

  async update(id: number, data: any) {
    const payload = data?.imageFile ? buildFichaPayload(data) : data;
    const response = await api.put(`/fichas/${id}`, payload);
    return response.data;
  },

  async updateStatus(id: number, status: "ativa" | "inativo") {
    if (status !== "ativa" && status !== "inativo") {
      throw new Error("Status inválido. Utilize 'ativa' ou 'inativo'.");
    }
    const response = await api.patch(`/fichas/${id}/status`, { status });
    return response.data;
  },

  async delete(id: number) {
    const response = await api.delete(`/fichas/${id}`);
    return response.data;
  },
};
